import { useEffect, useRef } from 'react';
import { socket } from '../utils/api';

const useSuppliers = (onUpdate) => {
  const callback = useRef(onUpdate);

  useEffect(() => {
    socket.on(`supplier`, (message) => {
      if (message.caller !== socket.id) {
        callback.current(message.data.type, message.name, message.data.name);
      }
    });
    return () => {
      socket.off(`supplier`);
    };
  }, []);
};

export default useSuppliers;
